export default __webpack_public_path__ + "static/media/internalLink.1d491a8b.svg";